import React, { useContext } from "react";
import { ProtectedLayout } from "./ProtectedLayout";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { RolePermission } from "../../interfaces/interfaces";

interface Props {
  children: JSX.Element | JSX.Element[];
  role?: null | RolePermission;
}
export const ProtectedRoute = ({ role, children }: Props) => {
  const { validateToken, onLogout, role: userRole } = useContext(AuthContext);
  const location = useLocation();

  if (!validateToken()) {
    onLogout();
    return <Navigate to="/login" replace />;
  }

  if (role && role !== userRole) {
    return <Navigate to="/login" replace />;
  }

  if (
    userRole === "SUPER_ADMIN" &&
    !location.pathname.startsWith("/super-admin")
  ) {
    return <Navigate to="/super-admin/users" replace />;
  }

  return <ProtectedLayout>{children}</ProtectedLayout>;
};
